import { render, staticRenderFns } from "./NotesBox.vue?vue&type=template&id=00ec636a&scoped=true&lang=pug"
import script from "./NotesBox.vue?vue&type=script&lang=js"
export * from "./NotesBox.vue?vue&type=script&lang=js"
import style0 from "./NotesBox.vue?vue&type=style&index=0&id=00ec636a&prod&lang=scss&scoped=true"
import style1 from "./NotesBox.vue?vue&type=style&index=1&id=00ec636a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec636a",
  null
  
)

export default component.exports